<div class="row" *ngIf="nextAction.text1 || nextAction.text2 || nextAction.bankTransferInstructions?.length">
  <div class="col-12">
    <div *ngIf="nextAction.text1" appFormatText [text]="nextAction.text1" [link]="nextAction.hyperLink" [email]="email"></div>
    <div *ngIf="nextAction.text2" [innerHTML]="nextAction.text2 | safeHTML"></div>
    <div class="mt-2" *ngIf="nextAction.bankTransferInstructions?.length">
      <p>
        {{ 'summary.next.text' | translateLang }}
      </p>
      <p>{{ 'summary.next.email' | translateLang }}</p>
      <div [innerHTML]="nextAction.bankTransferInstructions | safeHTML"></div>
    </div>
    <img *ngIf="nextAction.logoUrl" [src]="nextAction.logoUrl" alt="foundation-logo" class="logo" />
  </div>
</div>
